var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6745 16.46C13.3144 15.7178 12.8489 15.1776 12.0452 15.507L10.4598 16.0954C9.1906 16.6839 8.55819 16.0954 7.9214 15.2083L5.06679 8.7174C4.70667 7.9752 4.89552 7.27692 5.6992 6.94754L7.917 6.06042C8.72068 5.72665 8.59333 5.03277 8.23321 4.29057L6.34038 0.750861C5.98027 0.00866465 5.24246 -0.171395 4.43878 0.157982C2.82703 0.821128 1.49634 1.86196 0.635572 3.40345C-0.418435 5.28748 0.108569 7.90933 0.31937 9.01164C0.530172 10.114 1.26798 12.0463 2.22097 14.027C3.17397 16.012 4.00839 17.5711 4.75937 18.4538C5.50596 19.3365 7.29777 21.752 9.51558 22.2921C11.3337 22.7313 13.2968 22.3624 14.9042 21.6993C15.7079 21.3699 15.7123 20.6716 15.3521 19.925L13.6745 16.46Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLeft);
export default __webpack_public_path__ + "static/media/callLeft.e1a2f51716142ee6f548296ecc1b7ccc.svg";
export { ForwardRef as ReactComponent };